import styled, { css } from 'styled-components';

import { spacing, colors, borderRadius } from '../../../styles/theme';

import { ReactComponent as Check } from '../../../assets/icons/icon_check.svg';
import { ReactComponent as Error } from '../../../assets/icons/icon_error.svg';
import { ReactComponent as Warning } from '../../../assets/icons/icon_warning.svg';

interface CardStatusProps {
  readonly minHeight?: number;
}

export const CardStatus = styled.div<CardStatusProps>`
  display: flex;
  border: 1px solid ${colors(`black.08`)};
  box-sizing: border-box;
  border-radius: ${borderRadius('large')};
  width: 100%;
  min-height: ${({ minHeight }: CardStatusProps) => (minHeight ? `${minHeight}px` : 'auto')};
  margin-top: ${spacing('4')};
`;

export const CardStatusText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${spacing('2')} ${spacing('1')};
`;

interface IconContainerProps {
  type: 'danger' | 'success' | 'warning';
}

export const IconContainer = styled.div<IconContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ type }: IconContainerProps) => colors(`${type}.light`)};
  border-radius: ${borderRadius('large')} 0px 0px ${borderRadius('large')};
  min-width: 66px;
`;

interface IconProps {
  size?: number;
  $notFlex?: boolean;
}

export const IconCheck = styled(Check)<IconProps>`
  width: ${({ size }: IconProps) => size || 34}px;
  height: ${({ size }: IconProps) => size || 34}px;

  ${({ $notFlex }: IconProps) =>
    $notFlex &&
    css`
      flex: none;
    `};
`;

export const IconError = styled(Error)<IconProps>`
  width: ${({ size }: IconProps) => size || 34}px;
  height: ${({ size }: IconProps) => size || 34}px;

  ${({ $notFlex }: IconProps) =>
    $notFlex &&
    css`
      flex: none;
    `};
`;

export const IconWarning = styled(Warning)<IconProps>`
  width: ${({ size }: IconProps) => size || 34}px;
  height: ${({ size }: IconProps) => size || 34}px;

  ${({ $notFlex }: IconProps) =>
    $notFlex &&
    css`
      flex: none;
    `};
`;
